import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './ObjectsDisclaimer.css';

export interface IObjectsDisclaimerProps {
  isVisible: boolean;
  mediaType: 'desktop' | 'mobile';
}

export const ObjectsDisclaimer: React.FC<IObjectsDisclaimerProps> = ({ isVisible, mediaType }) => {
  if (!isVisible) {
    return null;
  }
  const isMobile = mediaType === 'mobile';

  return (
    <div {...mergeStyles(styles['container'], isMobile && styles['container-mobile'])}>
      <div className={styles['text_container']}>
        <span className={styles['text']}>Возможно, информация о посёлке устарела. Уточняйте подробности.</span>
      </div>
    </div>
  );
};
